import { createSelector } from "../../utils/selectors.js";
const selectorChartAnimationState = state => state.animation;
export const selectorChartSkipAnimation = createSelector([selectorChartAnimationState], state => state.skip || state.skipAnimationRequests > 0);